import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthenticationService } from '../services';

@Injectable({
    providedIn: 'root',
})
export class DashboardDefaultRouteGuard implements CanActivate {
    constructor(private router: Router, private authentication: AuthenticationService) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlTree | boolean {
        if (state.url !== '/dashboard') {
            return true;
        }

        const routeChildren = next.routeConfig?.children;

        if (!routeChildren) {
            return false;
        }

        const userAccessScope = this.authentication.user.role.accessScope;

        for (const childRoute of routeChildren) {
            // return the first route allowed to the user
            if (childRoute.data && userAccessScope.indexOf(childRoute.data.scopeKey) >= 0) {
                return this.router.parseUrl(`/dashboard/${childRoute.path}`);
            }
        }

        return false;
    }
}
